import type { parsedApiError } from "@/types/api/errors.api";
import type { simulation } from "../dashboard/types.api";

interface pageState {
    isModalOpen: boolean;
    editingSimulation: simulation | null;
    actionError: parsedApiError | null;
}

type pageAction =
    | { type: "OPEN_MODAL"; payload?: simulation }
    | { type: "CLOSE_MODAL" }
    | { type: "SET_ACTION_ERROR"; payload: parsedApiError }
    | { type: "CLEAR_ACTION_ERROR" };

export const initialState: pageState = {
    isModalOpen: false,
    editingSimulation: null,
    actionError: null,
};

export const pageReducer = (state: pageState, action: pageAction): pageState => {
    switch (action.type) {
        case "OPEN_MODAL":
            return {
                ...state,
                isModalOpen: true,
                editingSimulation: action.payload || null,
                actionError: null,
            };
        case "CLOSE_MODAL":
            return { ...state, isModalOpen: false, editingSimulation: null };
        case "SET_ACTION_ERROR":
            return { ...state, actionError: action.payload };
        case "CLEAR_ACTION_ERROR":
            return { ...state, actionError: null };
        default:
            return state;
    }
};
